export const icons: {[key: string]: string} = {
    'arrows-alt-h': '\uf337',
    'arrow-right': '\uf061',
    'bed': '\uf236',
    'bell': '\uf0f3',
    'box': '\uf466',
    'calendar': '\uf133',
    'cloud': '\uf0c2',
    'chevron-circle-right': '\uf138',
    'chevron-right': '\uf054',
    'circle': '\uf111',
    'circle-notch': '\uf1ce',
    'clock': '\uf017',
    'code': '\uf121',
    'compress': '\uf066',
    'cube': '\uf1b2',
    'cog': '\uf013',
    'comment': '\uf075',
    'code-branch': '\uf126',
    'credit-card': '\uf09d',
    'check': '\uf00c',
    'database': '\uf1c0',
    'envelope': '\uf0e0',
    'ellipsis-h': '\uf141',
    'exchange-alt': '\uf362',
    'expand': '\uf065',
    'file': '\uf15b',
    'file-alt': '\uf15c',
    'file-code': '\uf1c9',
    'filter': '\uf0b0',
    'forward': '\uf04e',
    'grip-vertical': '\uf58e',
    'hdd': '\uf0a0',
    'inbox': '\uf01c',
    'keyboard': '\uf11c',
    'link': '\uf0c1',
    'list': '\uf03a',
    'microchip': '\uf2db',
    'object-group': '\uf247',
    'play': '\uf04b',
    'play-circle': '\uf144',
    'puzzle-piece': '\uf12e',
    'pause': '\uf04c',
    'pause-circle': '\uf28b',
    'redo-alt': '\uf2f9',
    'satellite-dish': '\uf7c0',
    'save': '\uf0c7',
    'sign-out-alt': '\uf2f5',
    'sitemap': '\uf0e8',
    'stream': '\uf550',
    'square': '\uf0c8',
    'sync-alt': '\uf2f1',
    'tasks': '\uf0ae',
    'th': '\uf00a',
    'times': '\uf00d',
    'times-circle': '\uf057',
    'undo-alt': '\uf2ea',
    'window-restore': '\uf2d2',
    'window-maximize': '\uf2d0'
};
